import React, { useEffect, useState, useContext } from 'react'
import AuctionTableView from '@/product/components/organisms/Auction/TableView'
import { Button, Menu, MenuItem, Popover } from '@mui/material'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ReportContext from '@/product/context/report/reportContext'
import AuctionListing from '../AuctionLots/AuctionListing'
import { useHistory } from 'react-router'
import DynamicAuctionListing from '../AuctionLots/dynamicListing'
import DynamicListing from '../Listing/dynamicListing'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import DynamicBulkImage from '@/product/components/organisms/BulkUpload/ProjectImage'
import { handleRedirectInternal } from '@/product/common/components'
import Catalogue from './Catalogue'

const ErpAuction = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { auction_tablefields } = dynamicContext
    const history = useHistory()
    const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [listingManage, setListingManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const [bulkImagePopup, setBulkImagePopup] = useState(false)
    const [catalogPopup, setCatalogPopup] = useState(false)
    const [actionsAAnchor, setActionsAnchor] = useState(null)

    const handlePhotosClick = (event) => {
        setActionsAnchor(event.currentTarget)
    }

    const handleClose = () => {
        setActionsAnchor(null)
    }

    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }
    const toggleCatalougePopup = (popup) => {
        setCatalogPopup({ popup })
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        console.log(popup, status, id, 'toggle')
        console.log('lllll')
        if (popup && status == 'edit') {
            handleRedirectInternal(history, `auction/edit/${id}`)
        }
    }

    const toggleListingPopup = (popup, status, id) => {
        if (popup && status != '') {
            handleRedirectInternal(history, `listing/${status}/${id}`)
        }
    }

    let action = props.action

    const custom = {
        action: {
            value: action == 'all' ? '' : action,
            type: 'in',
            field: 'ac.market_status',
        },
    }

    useEffect(() => {
        if (auction_tablefields && auction_tablefields.length) {
            const updated_auction_tablefields = auction_tablefields.map(
                (column) => ({
                    ...column,
                    multipleFields: column.field.includes(','),
                })
            )
            let dynamicValueAssign = {}
            let searchData = updated_auction_tablefields
            setTableValue(searchData)
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            setSearchInfo(dynamicValueAssign)
        }
    }, [auction_tablefields, action])

    return (
        <>
            <div className="dashboard listing maillisting erpMisc">
                <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 erp-menus-list">
                    <Button
                        id="dynamicAuction_add"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() =>
                            handleRedirectInternal(history, `auction/new/0`)
                        }
                    >
                        <span className="material-icons">add</span>
                        Create a new auction
                    </Button>
                    <Button
                        id="listingDynamic_add"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => toggleListingPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">add</span>
                        Add single inventory
                    </Button>
                    <Button
                        id="listingDynamic_bulk"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => toggleBulkPopup(true)}
                    >
                        <span className="material-icons-outlined">
                            inventory_2
                        </span>
                        Add bulk inventory
                    </Button>
                    <Button
                        id="dynamicAuction_report"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() =>
                            getAllExportDownload({
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `${action}_auction_management`,
                            })
                        }
                    >
                        <span className="material-icons-outlined">
                            file_download
                        </span>
                        Export All Data
                    </Button>
                    <Button
                        variant="outlined"
                        className="btnOutlined moreActions"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handlePhotosClick}
                    >
                        More Actions
                        <span className="material-icons">expand_more</span>
                    </Button>
                    <Popover
                        id="simple-menu"
                        anchorEl={actionsAAnchor}
                        keepMounted
                        open={Boolean(actionsAAnchor)}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                toggleBulkImagePopup(true)
                                handleClose()
                            }}
                        >
                            Add Bulk Images
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                toggleCatalougePopup(true)
                                handleClose()
                            }}
                        >
                            View Catalog
                        </MenuItem>
                        <MenuItem
                            onClick={() =>
                                handleRedirectInternal(
                                    history,
                                    'campaign/template'
                                )
                            }
                        >
                            View Marketing
                        </MenuItem>
                    </Popover>
                </div>
                {console.log(tableValue, 'tableValueCheck')}

                <AuctionTableView
                    searchInfo={searchInfo}
                    customFilter={custom}
                    tableValue={tableValue}
                    toggleFullScreenPopup={toggleFullScreenPopup}
                    tableActionString={
                        global?.auction_tableActionString
                            ? global?.auction_tableActionString
                            : []
                    }
                    action={action}
                    showInvoice={
                        global?.auction_showInvoice
                            ? global?.auction_showInvoice
                            : false
                    }
                    toggleBulkImagePopup={toggleBulkImagePopup}
                    viewStore={global?.viewStore ? global?.viewStore : false}
                    editLot={global?.editLot ? global?.editLot : false}
                    listView={global?.listView ? global?.listView : false}
                />
            </div>
            {/* <AuctionListing data={manage} function={toggleFullScreenPopup} />
            <DynamicAuctionListing
                data={manage}
                function={toggleFullScreenPopup}
            /> */}
            {/* <DynamicListing
                data={listingManage}
                function={toggleListingPopup}
            /> */}
            <Catalogue data={catalogPopup} function={toggleCatalougePopup} />
            <DynamicBulkListing
                data={bulkPopup}
                function={toggleBulkPopup}
                ignoreFields={
                    global?.bulk_ignoreFields ? global.bulk_ignoreFields : []
                }
            />
            <DynamicBulkImage
                data={bulkImagePopup}
                function={toggleBulkImagePopup}
                explanationText={`Bulk Image Upload reads the file name of each image and will automatically add to the listings image. The name of the files has to be given in the format of {AuctionField}_{ListingField}-{N}.{ImageFormat} or {AuctionField}_{ListingField} ({N}).{ImageFormat}. <br />  {AuctionField} From Auction Posting: "Auction Cycle" Field has to be given first. <br/> {ListingField} From Listing Posting: "Lot ID" Field has to be given. <br/> {N} Number - Can be any number, as uploading multiple images with same name is not possible, When renaming the number will be automatically added by OS (Mac or Windows). <br /> {ImageFormat} Image Format: Image Format can be .jpg, .png or .webp. <br /> Between the two fields "_" should be given.`}
                separatorFunction={[
                    {
                        symbol: '_',
                        field: 'cac.auction_cycle',
                        table: 'auction',
                        show: 'Auction Cycle',
                    },
                    {
                        symbol: '_',
                        field: 'it.auction_lot',
                        table: 'project',
                        show: 'Lot ID',
                    },
                ]}
                isCompress={global?.isCompress ? global.isCompress : false}
            />
        </>
    )
}

export default ErpAuction
